import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---- ResizeObserver "loop completed" noise fix ----
// The Travelpayouts widget triggers synchronous layout changes during its own
// ResizeObserver callback, which browsers report as a benign loop warning. CRA's
// react-error-overlay surfaces these as full-screen runtime errors in dev. We
// wrap ResizeObserver so callbacks fire on the next animation frame, which is
// the community-recommended fix and eliminates the warning entirely.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class PatchedRO extends OriginalRO {
    constructor(cb) {
      let rafId = 0;
      const wrapped = (entries, observer) => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          try {
            cb(entries, observer);
          } catch (err) {
            // TP widget occasionally re-layouts inside its own RO callback; log in dev only.
            if (process.env.NODE_ENV !== "production") console.warn("ResizeObserver callback error:", err?.message || err);
          }
        });
      };
      super(wrapped);
    }
  };
}
const RESIZE_OBSERVER_MSG = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e.message && RESIZE_OBSERVER_MSG.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
